import React from "react";
import "../styles/WhyChooseMe.css";

import communityIcon from "../assets/svg/community.svg";
import flexibilityIcon from "../assets/svg/flexibility.svg";
import iterationIcon from "../assets/svg/iteration.svg";
import stabilityIcon from "../assets/svg/stability.svg";

const WhyChooseMe = () => {
  return (
    <section className="why-section" id="rolunk">
      <div className="why-container">
        <h2 className="why-title">Miért válassz engem?</h2>
        <p className="why-sub">Több szabadság, kevesebb bizonytalanság</p>

        <div className="why-grid">
          {/* 1. Stability */}
          <div className="why-card">
            <img src={stabilityIcon} alt="Stability" className="why-icon" />
            <h3 className="why-card-title">20+ éve élek abból, amit tanítok</h3>
            <p className="why-card-text">
              Olyan rendszert kapsz, amely stabil alapokat ad — bonyolult
              elméletek és túlzó ígéretek nélkül.
            </p>
          </div>

          {/* 2. Iteration */}
          <div className="why-card">
            <img src={iterationIcon} alt="Iteration" className="why-icon" />
            <h3 className="why-card-title">Valódi, bizonyított módszer</h3>
            <p className="why-card-text">
              Nem elméletet oktatok, hanem azt, ami nálam működött: lépésről
              lépésre felépíthető, követhető út nőknek, akik több szabadságra és
              biztonságra vágynak.
            </p>
          </div>

          {/* 3. Community */}
          <div className="why-card">
            <img src={communityIcon} alt="Community" className="why-icon" />
            <h3 className="why-card-title">
              Működő közösség, valódi támogatás
            </h3>
            <p className="why-card-text">
              Nem maradsz egyedül. Egy olyan női közösségbe érkezel, ahol
              segítjük egymást, együtt fejlődünk, és minden út elején ott állok
              melletted.
            </p>
          </div>

          {/* 4. Flexibility */}
          <div className="why-card">
            <img src={flexibilityIcon} alt="Flexibility" className="why-icon" />
            <h3 className="why-card-title">
              Rugalmasság, ami illeszkedik az életedhez
            </h3>
            <p className="why-card-text">
              A módszer megvalósítható gyerekek mellett, munka mellett vagy
              teljesen újrakezdőként is — nincs szükséged előképzettségre, csak
              elhatározásra.
            </p>
          </div>
        </div>

        <a href="/contact" className="why-btn">
          Belevágok
        </a>
      </div>
    </section>
  );
};

export default WhyChooseMe;
